import styled from 'styled-components'

export const StyledCountInfo = styled.div`
  line-height: 16px;
  border-radius: 4px;
  padding: 1px 3px;
  color: #ffffff;
  background: #1cb954;
  min-width: 17px;
  font-size: 10px;
  font-weight: normal;
  display: inline-block;
`
export const StyledCountNumber = styled.span`
  display: flex;
  justify-content: space-around;
`
